{
  "version": 1,
  "asset_id": "380cec17-a01e-45c1-bc6e-40492223b550",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/380cec17-a01e-45c1-bc6e-40492223b550/sleeve-normal-revision.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/380cec17-a01e-45c1-bc6e-40492223b550/sleeve-normal-revision.png",
  "original_filename": "sleeve-normal-revision.png",
  "size": 555777,
  "content_type": "image/png",
  "created_at": "2026-10-05T01:21:24Z"
}
